import React from 'react';

import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import prompt from 'antd-prompt';

import AddButton from 'components/action/AddButton';
import StakefactorEditionModal from 'components/Modal/StakefactorEditionModal';

import {
	useCreateStakefactorMutation,
	useDeleteStakefactorMutation,
	useUpdateStakefactorMutation,
} from '../../../graphql/generated';

import NavigationButton from 'components/action/NavigationButton';
import Weight from 'components/controls/Weight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { Button, Tooltip, Typography, Flex } from 'antd';
import Table from 'components/Table';

import './Stakefactors.sass';

export const Stakefactors = (props: any) => {
	const [editedItem, setEditedItem] = React.useState<any | null>(null);

	const params: any = useParams();
	const [createStakefactor] = useCreateStakefactorMutation();
	const [deleteData] = useDeleteStakefactorMutation();
	const [updateData] = useUpdateStakefactorMutation();
	const { t } = useTranslation();

	const { stakefactors = [] } = props;

	// Create
	const handleCreateStakefactor = async () => {
		const name: any = await prompt({
			title: t("models.stakefactor.fields.name_explanation"),
			rules: [
				// check this link for more help: https://ant.design/components/form/#Validation-Rules
				{
					required: true,
					message: 'You must enter a name',
				},
			],
		});

		await createStakefactor({
			variables: {
				projectId: params.id,
				name: name,
				weight: 1,
				description: '',
			},
		});

		await props.refetch();
	};

	// Update
	const handleUpdateStakefactor = async (id: string, values: Object) => {
		await updateData({
			variables: {
				id: id,
				...values,
			},
		});

		await props.refetch();
	};

	// Delete
	const handleDelete = async (id: string | undefined) => {
		console.log('deleteData', id);

		if (id == null) {
			return;
		}

		await deleteData({
			variables: { id: id },
		});

		await props.refetch();
	};


	const columns = [
		{
			title: '',
			dataIndex: 'edit',
			key: 'edit',
			width: 40,
			render: (text, record) => (
				<Tooltip title={props.scenario ? null : 'Edit'}>
					<Button
						shape="circle"
						disabled={props.scenario ? true : false}
						style={{ opacity: props.scenario ? 0.2 : 1 }}
						onClick={
							props.disabled
								? () => { }
								: () => {
									setEditedItem(record);
								}
						}
					>
						<FontAwesomeIcon
							icon={faEdit}
							style={{
								cursor: props.disabled
									? 'not-allowed'
									: 'initial',
								opacity: props.disabled ? 0.5 : 1
							}}
						/>
					</Button>
				</Tooltip>
			)
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			className: 'w-100',
			sortable: true,
			defaultSortOrder: 'ascend',
			ellipsis: true,
			render: (text, record) => {
				return (
					<div className="name">
						{record.name}
						<div className="description">
							{record.description}
						</div>
					</div>
				);
			}
		},
		{
			title: 'Weight',
			dataIndex: 'weight',
			key: 'weight',
			sortable: true,
			width: 100,
			render: (text, record) => {
				return (
					<Weight
						style={{ marginRight: '0.5rem' }}
						onClick={(values: any) => {
							console.log('values', values);
							let newWeight = record.weight !== null && record.weight !== undefined ? record.weight + 1 : 1;
							if (newWeight > 3) newWeight = 0;
							handleUpdateStakefactor(record.id, { weight: newWeight });
						}}
						disabled={!!props.scenario}
					>
						{record.weight}
					</Weight>
				);
			}
		}
	];

	return (
		<div className="Stakefactors pb-3">
			<Typography.Title level={2}>{t('pages.stakefactors.title')}</Typography.Title>
			{false && <Typography.Title level={3}>{t('pages.stakefactors.subtitle')}</Typography.Title>}

			<div className="mb-3 mt-4 w-100" style={{ maxWidth: '1200px' }}>
				<Table
					pagination={false}
					dataSource={stakefactors}
					columns={columns}
					size="small"
				/>
			</div>

			{editedItem && (
				<StakefactorEditionModal
					onHide={() => {
						setEditedItem(null);
					}}
					onDelete={() => {
						handleDelete(editedItem.id);
						setEditedItem(null);
					}}
					onSave={(values: Object) => {
						handleUpdateStakefactor(editedItem.id, values);
						setEditedItem(null);
					}}
					id={editedItem?.id}
					values={{
						name: editedItem?.name,
						description: editedItem?.description,
						weight: editedItem?.weight !== null && editedItem?.weight !== undefined ? editedItem?.weight : 1,
					}}
				></StakefactorEditionModal>
			)}

			<Flex justify="center" align="center" className="w-100">
				<AddButton onClick={handleCreateStakefactor}></AddButton>
				<NavigationButton className="ml-4" onClick={() => props.onGoNext('/projects/' + props?.id + '/' + t("models.option.slug"))}>
					Next step
				</NavigationButton>
			</Flex>

		</div>
	);
};
